import { useMutation } from '@tanstack/react-query';

import { connectToVendingMachine } from '../api/order.api';

interface ConnectParams {
    qr: string;
    nfc: boolean;
    timerTime?: number;
}

export const useConnectToVendingMachine = () => {
    return useMutation({
        mutationFn: ({ qr, nfc, timerTime }: ConnectParams) =>
            connectToVendingMachine(qr, nfc, timerTime),
    });
};
